import { api } from "@/services/api"
import axios from "axios"

import type {
  PagarmePixOrderRequest,
  PagarmePixOrderResponse,
  PagarmePixOrderStatusResponse,
  PagarmeSubscriptionRequest,
  PagarmeSubscriptionResponse,
  PendingPaymentResponse,
} from "../types"

const BILLING_API_BASE = "/billing"
const PAGARME_API_BASE = "https://api.pagar.me/core/v5"

export const pagarmeService = {
  async createSubscription(data: PagarmeSubscriptionRequest): Promise<PagarmeSubscriptionResponse> {
    const response = await api.post<PagarmeSubscriptionResponse>(
      `${BILLING_API_BASE}/pagarme/create-subscription`,
      data
    )
    return response.data
  },

  async cancelSubscription(reason?: string): Promise<{ subscription_id: string; status: string }> {
    const response = await api.post(`${BILLING_API_BASE}/pagarme/cancel-subscription`, {
      reason,
    })
    return response.data
  },

  async updatePaymentMethod(
    cardToken: string
  ): Promise<{ subscription_id: string; card_last4: string; card_brand: string }> {
    const response = await api.post(`${BILLING_API_BASE}/pagarme/update-payment-method`, {
      card_token: cardToken,
    })
    return response.data
  },

  async upgradePlan(data: {
    new_plan_id: string
    payment_method: string
    card_token?: string
    installments?: number
  }): Promise<{ subscription_id: string; status: string }> {
    const response = await api.post(`${BILLING_API_BASE}/pagarme/upgrade-plan`, data)
    return response.data
  },

  async createPixOrder(data: PagarmePixOrderRequest): Promise<PagarmePixOrderResponse> {
    const response = await api.post<PagarmePixOrderResponse>(
      `${BILLING_API_BASE}/pagarme/create-pix-order`,
      data
    )
    return response.data
  },

  async checkPixOrderStatus(orderId: string): Promise<PagarmePixOrderStatusResponse> {
    const response = await api.get<PagarmePixOrderStatusResponse>(
      `${BILLING_API_BASE}/pagarme/pix-order-status/${orderId}`
    )
    return response.data
  },

  async getPendingPayment(): Promise<PendingPaymentResponse> {
    const response = await api.get<PendingPaymentResponse>(
      `${BILLING_API_BASE}/pagarme/pending-payment`
    )
    return response.data
  },

  async tokenizeCard(
    publicKey: string,
    cardData: {
      number: string
      holder_name: string
      exp_month: number
      exp_year: number
      cvv: string
    }
  ): Promise<string> {
    const response = await axios.post(`${PAGARME_API_BASE}/tokens?appId=${publicKey}`, {
      type: "card",
      card: cardData,
    })
    return response.data.id
  },
}
